module.exports = {
      id: "corona-updates-icon-usage",
      viewBox: "0 0 25.374 25.18",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#corona-updates-icon",
      toString: function () {
        return this.url;
      }
    }